import { h, Component, AnyComponent } from 'preact'

interface ComponentInModule<T> {default: AnyComponent<T>}

type LoaderFn<InnerProps> = () => Promise<ComponentInModule<InnerProps>>

interface State<InnerProps> {
  component?: ComponentInModule<InnerProps>
}

export default function DynamicImport<InnerProps extends unknown> (loader: LoaderFn<InnerProps>) {
  return class extends Component<InnerProps, State<InnerProps>> {
    async componentDidMount () {
      this.setState({
        component: await loader()
      })
    }

    render () {
      if (!this.state.component) return null

      const InnerComponent = this.state.component.default
      return <InnerComponent {...this.props} key='lazy-component' />
    }
  }
}

// Example usage:
// const Component = LazyLoader(async () => await import('../control-components/codemirror/codemirror.lazy'))
// return <Component onChange={(_data: string) => {}} />
